import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "login-common-style Code" }
const _hoisted_2 = { class: "iphone" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("em", null, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "validation2"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "validation",
  style: {"margin-bottom":"10px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("em", null, null, -1)
const _hoisted_9 = {
  key: 1,
  class: "min"
}
const _hoisted_10 = { class: "forget" }

import { reactive, ref, computed } from "vue";
import { ElMessage } from "element-plus";
import i18n from "@/lang";
import { setCookie } from "@/utils/cookies";
import store from "@/store";
import { AuthTokenType, ImageCodeType } from "@/types/login";
import {
  checkFrequentRequest,
  checkCaptchaCode,
  getSendMobileCode,
  getAuthToken,
  getSendEmailCode,
} from "@/api/login";
import { ResultCommon } from "@/types/common";
import { isNoviceuidance } from "@/utils/driver";
import { mobileGotoNext, isEmail, isPhone } from "@/utils/index";
import { ForgetSendCodeType } from "@/types/setPassword";
interface VerificationCodeLoginType {
  mobile: string;
  verificationCode: string;
  captchaCode: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  emits: ["handleAccount"],
  setup(__props, { emit: emits }) {

const isMobile = store.state.isMobile;
const language = computed(() => store.state.appLanguage);
const form: VerificationCodeLoginType = {
  mobile: "",
  verificationCode: "",
  captchaCode: "",
};
const t = i18n.global.t;
const loginForm = reactive(form);
const frequentRequest = reactive({
  url: "",
  isShow: false,
});

// 判断当前用户是否显示曝光页
const activePageState = computed(() => store.state.activePageState);
const changeDialogState = () => {
  if (activePageState.value == false) {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    document.getElementsByTagName("body")[0].classList.add("stop-scroll-top");
    store.commit("isShowActivePage", true);
  }
};

const time = ref(60);
const sendCodeText = ref("");
const autoSendImageCode = () => {
  if (loginForm.captchaCode.length == 4) {
    checkCaptchaCode({
      mobile: loginForm.mobile,
      verificationCode: loginForm.captchaCode,
    }).then((res: ResultCommon) => {
      if (res.code == 0) {
        sendCode();
      }
    });
  }
};

const checkFrequentRequestFn = () => {
  checkFrequentRequest({
    mobile: loginForm.mobile,
  }).then((res: ImageCodeType) => {
    if (res.code == 0) {
      let data = res.data;
      if (data.isVerification == 1) {
        frequentRequest.url = `data:image/png;base64,${data.image}`;
        frequentRequest.isShow = true;
      } else {
        sendCode();
        frequentRequest.isShow = false;
      }
    }
  });
};
const handleSendCode = () => {
  if (time.value != 60) {
    return false;
  }
  if (!loginForm.mobile) {
    ElMessage.error(t("login.login_email_iphone"));
    return;
  }

  if (language.value === "en" && !isEmail(loginForm.mobile)) {
    console.log(t("login.email_format_error"));
    ElMessage.error(t("login.email_format_error"));
    return;
  }
  if (frequentRequest.isShow || isEmail(loginForm.mobile)) {
    sendCode();
  } else {
    checkFrequentRequestFn();
  }
};
const sendCode = () => {
  let action: any = getSendMobileCode,
    params: ForgetSendCodeType = {
      mobile: loginForm.mobile,
    };
  if (isEmail(loginForm.mobile)) {
    action = getSendEmailCode;
    params = {
      email: loginForm.mobile,
    };
  }
  action(params).then((res: any) => {
    if (res.code == 0) {
      frequentRequest.isShow = false;
      timer();
    }
  });
};

const timer = () => {
  if (time.value > 0) {
    time.value--;
    sendCodeText.value = time.value + "s";
    setTimeout(timer, 1000);
  } else {
    time.value = 60;
  }
};

const submit = () => {
  if (!loginForm.mobile) {
    ElMessage.error(t("login.login_email_iphone"));
    return;
  }
  if (!loginForm.verificationCode) {
    ElMessage.error(t("user_center.code_none"));
    return;
  }

  if (loginForm.mobile.indexOf("@") !== -1) {
    if (!isEmail(loginForm.mobile)) {
      ElMessage.error(i18n.global.t("login.please_enter_the_account"));
      return;
    }
  } else {
    if (!isPhone(loginForm.mobile)) {
      ElMessage.error(i18n.global.t("login.please_enter_the_account"));
      return;
    }
  }
  let query = `grant_type=mobile_code&mobile=${loginForm.mobile}&code=${loginForm.verificationCode}&account_type=`;

  if (isEmail(loginForm.mobile)) {
    query = `grant_type=email_code&email=${loginForm.mobile}&code=${loginForm.verificationCode}`;
  }
  getAuthToken(query).then((res: AuthTokenType) => {
    if (res.code == 0) {
      let data = res.data;
      setCookie("token", data.access_token);
      loginForm.mobile = "";
      loginForm.verificationCode = "";
      loginForm.captchaCode = "";
      frequentRequest.url = "";
      frequentRequest.isShow = false;
      store.dispatch("getUserInfo");
      mobileGotoNext("home");
      if (!isMobile) {
        setTimeout(() => {
          isNoviceuidance();
        }, 1500);
      } else {
        changeDialogState();
      }
    }
  });
};

const handleAccount = () => {
  emits("handleAccount");
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_input, {
        modelValue: loginForm.mobile,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.mobile) = $event)),
        placeholder: _ctx.$t('login.login_email_iphone'),
        clearable: ""
      }, null, 8, ["modelValue", "placeholder"])
    ]),
    (frequentRequest.isShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("em", _hoisted_5))
            : _createCommentVNode("", true),
          _createVNode(_component_el_input, {
            onInput: autoSendImageCode,
            onkeyup: "value=value.replace(/[^\\d]/g,'')",
            modelValue: loginForm.captchaCode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.captchaCode) = $event)),
            placeholder: _ctx.$t('user_center.please_code'),
            maxlength: "4"
          }, null, 8, ["modelValue", "placeholder"]),
          _createElementVNode("img", {
            src: frequentRequest.url,
            alt: ""
          }, null, 8, _hoisted_6),
          _createElementVNode("a", {
            onClick: checkFrequentRequestFn,
            href: "javascript:;"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_el_input, {
        onkeyup: "value=value.replace(/[^\\d]/g,'') ",
        modelValue: loginForm.verificationCode,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loginForm.verificationCode) = $event)),
        placeholder: _ctx.$t('user_center.please_code'),
        maxlength: "6",
        onKeyup: _withKeys(submit, ["enter","native"])
      }, null, 8, ["modelValue", "placeholder", "onKeyup"]),
      (time.value === 60)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "send-button",
            onClick: handleSendCode
          }, _toDisplayString(_ctx.$t("user_center.send_code")), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(sendCodeText.value), 1))
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "default-color",
            onClick: handleAccount
          }, _toDisplayString(_ctx.$t("login.sign_in")), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      class: "btn mobile-btn-shadow",
      onClick: submit
    }, _toDisplayString(_ctx.$t("header.login")), 1)
  ]))
}
}

})